angular.module('impactx.login').controller('LoginChooseExternalDialogCtrl', [
    '$scope',
    'dataGen',
    '$rootScope',
    'themeFactory',
    'TranslationService',
    'AppConfiguration',
    loginChooseExternalDialogController]);

function loginChooseExternalDialogController($scope, dataGen, $rootScope, themeFactory, TranslationService, AppConfiguration) {
    var self = this;
    self.theme = themeFactory.getTheme();
    $scope.availableLanguages = AppConfiguration.get('availableLanguages');

    dataGen.getData($scope, {language: $rootScope.language, osuTan: self.osuTan}, "/login/externalauthorizations");

    $scope.changeLanguage = function (language) {
        $rootScope.language = language;
        TranslationService.getInitialTranslations(dataGen, language);
        dataGen.getData($scope, {language: $rootScope.language}, "/login/externalauthorizations");
    };

    /*
        Dirty hack to ensure the right flag for Serbia
        The way we retrieve language and country codes needs to be refactored in the future
     */
    $scope.getLanguageFlagCss = function (language) {
        language = language.toLowerCase();
        if (language === 'sr') {
            language = 'rs';
        }
        return 'flag-icon-' + language;
    }
}